/** @jsxImportSource @emotion/react */
import { PanelCard } from '../../../design-system/molecules/PanelCard/PanelCard';
import { Table } from '../../../design-system/molecules/Table/Table';
import { scrollStyle, rowStyle, cellStyle, headerTipStyle } from './DataGrid.styles';

export interface DataGridProps {
  /** 대상 테이블 스키마의 컬럼명 그대로. 모듈 전용 필드 하드코딩 금지. */
  columns: string[];
  rows: string[][];
  selectedIndex?: number;
  onSelectRow?: (index: number) => void;
  /** 컬럼명 → 설명 맵. 있으면 해당 머리글 hover 시 툴팁 표시. */
  comments?: Record<string, string>;
}

/** 범용 데이터 그리드. 스키마에서 읽은 컬럼으로 표를 그리고 행 선택을 노출. */
export function DataGrid({ columns, rows, selectedIndex, onSelectRow, comments }: DataGridProps) {
  // 주석이 있는 컬럼은 title 툴팁 + 힌트 밑줄로, 없으면 평문으로 렌더.
  const headers = columns.map((c) => {
    const tip = comments?.[c];
    return tip ? (
      <span css={headerTipStyle} title={tip}>
        {c}
      </span>
    ) : (
      c
    );
  });
  return (
    <PanelCard flush>
      <div css={scrollStyle}>
        <Table headers={headers}>
          {rows.map((row, i) => (
            <tr key={i} css={rowStyle(i === selectedIndex)} onClick={() => onSelectRow?.(i)}>
              {row.map((v, j) => (
                <td key={j} css={cellStyle}>
                  {v}
                </td>
              ))}
            </tr>
          ))}
        </Table>
      </div>
    </PanelCard>
  );
}
